<div class="folha">
  <div class="content">
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Como excluir o meu perfil? </mat-panel-title>
        </mat-expansion-panel-header>
        <p>
          Em preferências, há um botão na parte inferior com o nome de "Sair e Remover o Perfil". No entanto é
          necessário que você não esteja em nenhum grupo. Caso contrário, você precisará sair dos grupos ou, caso o
          grupo seja seu, remover todos os usuários do grupo para poder sair do jogo;
        </p>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Quantos grupos eu posso fazer parte? </mat-panel-title>
        </mat-expansion-panel-header>
        <p>Atualmente estamos com uma limitação de 5 grupos.</p>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
